export const messageLoaderState = {
  loadingMessage: null,
};
